module.exports = __webpack_public_path__ + "static/media/iv_thumbs_up.fb7e7ae8.svg";